import React, { useMemo } from "react";
import { setGlobalContextProperty } from "@jsq/observability";
import { useIdentifyArena } from "@jsq/flags-react";
import { toDbId } from "common/helpers/globalId";
import { ArenaProvider as ArenaContextProvider } from "common/constants/ArenaContext";
import { useGetCurrentArenaQuery, type ArenaObjectType } from "common/types/gqlSchemaTypes";

const ArenaProvider: React.FunctionComponent = (props) => {
  const { data, loading, error } = useGetCurrentArenaQuery({ fetchPolicy: "network-only" });
  const identifyArena = useIdentifyArena();

  const arena = useMemo<Partial<ArenaObjectType>>(() => {
    if (loading || error || !data?.currentArena) {
      return {};
    }

    if (data.currentArena) {
      const arenaId = toDbId(data.currentArena.id);
      setGlobalContextProperty("arenaId", arenaId);
      setGlobalContextProperty("arenaName", data.currentArena.name);
      identifyArena(arenaId);
    }
    return data.currentArena;
  }, [loading, error, data?.currentArena, identifyArena]);

  return <ArenaContextProvider value={arena}>{props.children}</ArenaContextProvider>;
};

export default ArenaProvider;
